module.exports = __webpack_public_path__ + "img/lab_physics.8cda725c.png";